import React from 'react';
import Table from '../../../Payments/Table';
import { reduceResolution, wbp } from 'Theme';
import { TableCell, TableRow } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useCommonStyles as useTableStyles } from '../../../Payments/Table/CommonStyles';
import moment from 'moment-timezone';
import store from 'store';
import { Pagination } from '@spike/model';
import { AppointmentDetailReport } from 'model/BookingsReport';
import { PriceFormat } from 'components/UI';

interface AppointmentsDetailTableProps {
    loading: boolean;
    items?: Array<AppointmentDetailReport> | null;
    pagination?: Pagination;
    changePageHandler: (pageSize: number) => void;
    changePageSizeHandler: (pageSize: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: 8,

            [theme.breakpoints.down('sm')]: {
                backgroundColor: '#FAFAFA'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: 16,
                margin: '0px -24px'
            }
        },
        header: {
            [theme.breakpoints.down(wbp)]: {
                paddingBottom: `${reduceResolution(63)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingBottom: '63px'
            }
        },
        cell: {
            fontWeight: 400,
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '15px'
            }
        },
        cellHeader: {
            padding: '20px 0px'
        },
        pagination: {
            [theme.breakpoints.down('sm')]: {
                paddingRight: '9px'
            },
            [theme.breakpoints.only('md')]: {
                paddingRight: '15px'
            },
            [theme.breakpoints.only('lg')]: {
                paddingRight: '20px'
            },
            [theme.breakpoints.only('xl')]: {
                paddingRight: '30px'
            }
        }
    })
);

export const AppointmentsDetailTable: React.FunctionComponent<AppointmentsDetailTableProps> = props => {
    const classes = useStyles();
    const tableStyles = useTableStyles();
    const timeZone = store.getState().login.auth.timeZone;

    const headersTable = (
        <>
            <TableCell className={tableStyles.headerCell}>Booking ID</TableCell>
            <TableCell className={tableStyles.headerCell}>Date Created</TableCell>
            <TableCell className={tableStyles.headerCell}>Date Scheduled</TableCell>
            <TableCell className={tableStyles.headerCell}>Client Name</TableCell>
            <TableCell className={tableStyles.headerCell}>Pet Name</TableCell>
            <TableCell className={tableStyles.headerCell}>Type</TableCell>
            <TableCell className={tableStyles.headerCell}>Item Name</TableCell>
            <TableCell className={tableStyles.headerCell}>Status</TableCell>
            <TableCell className={tableStyles.headerCell}>Duration</TableCell>
            <TableCell className={tableStyles.headerCell}>Staff</TableCell>
            <TableCell className={tableStyles.headerCell}>Created By</TableCell>
            {/* <TableCell className={tableStyles.headerCell}>Canceled By</TableCell> */}
            <TableCell className={tableStyles.headerCell}>Payment Status</TableCell>
            <TableCell className={tableStyles.headerCell}>Net Sales</TableCell>
        </>
    );

    const rowsItemDetail = (
        <>
            {props.items?.map(item => {
                const duration =
                    item.bookedAt && item.bookingEndAt
                        ? `${item.duration.to.clone().diff(item.duration.from.clone(), 'minutes')}min`
                        : '';

                const paymentStatus = item.paid ? 'Paid' : 'Pending';

                return (
                    <>
                        <TableRow>
                            <TableCell className={tableStyles.cell}>{item.bookingId}</TableCell>
                            <TableCell className={tableStyles.cell}>
                                {item.dateCreated ? moment(item.dateCreated, 'YYYY-MM-DD').format('MM/DD/YYYY') : null}
                            </TableCell>
                            <TableCell className={tableStyles.cell}>
                                {item.dateScheduled
                                    ? moment(item.dateScheduled, 'YYYY-MM-DD').format('MM/DD/YYYY')
                                    : null}
                            </TableCell>
                            <TableCell className={tableStyles.cell}>{item.clientName}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.petName}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.type}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.itemName}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.statusName}</TableCell>
                            <TableCell className={tableStyles.cell}>{duration}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.staff}</TableCell>
                            <TableCell className={tableStyles.cell}>{item.createdBy}</TableCell>
                            {/* <TableCell className={tableStyles.cell}>{item.canceledBy}</TableCell> */}
                            <TableCell className={tableStyles.cell}>{paymentStatus}</TableCell>
                            <TableCell className={tableStyles.cell}>
                                <PriceFormat price={item.netSales || ''} />
                            </TableCell>
                        </TableRow>
                    </>
                );
            })}
        </>
    );

    return (
        <div className={classes.root}>
            <Table
                headers={headersTable}
                rows={props.items ? rowsItemDetail : <></>}
                loading={props.loading}
                withoutColor={true}
                pagination={props.pagination}
                onChangePage={props.changePageHandler}
                onChangePageSize={props.changePageSizeHandler}
            />
        </div>
    );
};

export default AppointmentsDetailTable;
